import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { organizerMeApi, organizerListOrdersApi } from "../api/api";
import { handleError } from "../helpers/handleError";
import SpinLoading from "../components/spinLoading/SpinLoading";
import { fetchOrganizerDashboardStats } from "./services/dashboardStats";
import verificar from "./../assets/image/verificar 1.svg";
import sliderArrowIcon from "../assets/image/wallets/flecha-hacia-abajo 1.svg";
import legendArrowIcon from "../assets/image/wallets/Frame 48.svg";
import "./dashboard.css";

const baseOverviewOptions = [
  { value: "all", label: "Todos los eventos" },
  { value: "upcoming", label: "Proximos 30 dias" },
];

const activityOptions = [
  { value: "week", label: "Esta semana" },
  { value: "month", label: "Este mes" },
];

const TicketIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M5.5 6.5h13a1.5 1.5 0 0 1 1.5 1.5v2.3a1.7 1.7 0 0 0 0 3.4V16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 16v-2.3a1.7 1.7 0 0 0 0-3.4V8a1.5 1.5 0 0 1 1.5-1.5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 6.5v11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeDasharray="2 2" />
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
<path d="M10.4998 19.9052C10.1632 19.9057 9.8297 19.8397 9.51858 19.711C9.20746 19.5824 8.92481 19.3935 8.68684 19.1553L7.73221 18.1998C7.61631 18.0833 7.47846 17.9909 7.32661 17.9279C7.17477 17.865 7.01196 17.8328 6.84759 17.8332H5.72934C5.0496 17.8325 4.39791 17.5622 3.91726 17.0815C3.43662 16.6009 3.16628 15.9492 3.16559 15.2695V14.1521C3.1661 13.9878 3.13404 13.825 3.07126 13.6732C3.00848 13.5213 2.91623 13.3834 2.79984 13.2675L1.84434 12.3128C1.3643 11.8316 1.09473 11.1796 1.09473 10.4998C1.09473 9.8201 1.3643 9.1681 1.84434 8.68684L2.79984 7.73221C2.91639 7.61631 3.0088 7.47845 3.07173 7.32661C3.13466 7.17477 3.16686 7.01196 3.16646 6.84759V5.72934C3.16716 5.0496 3.43749 4.39791 3.91814 3.91726C4.39878 3.43662 5.05048 3.16628 5.73021 3.16559H6.84759C7.01189 3.1661 7.17467 3.13404 7.32651 3.07126C7.47835 3.00848 7.61624 2.91623 7.73221 2.79984L8.68684 1.84434C9.1681 1.3643 9.8201 1.09473 10.4998 1.09473C11.1796 1.09473 11.8316 1.3643 12.3128 1.84434L13.2675 2.79984C13.3834 2.91639 13.5212 3.0088 13.6731 3.07173C13.8249 3.13466 13.9877 3.16686 14.1521 3.16646H15.2703C15.9501 3.16716 16.6018 3.43749 17.0824 3.91814C17.5631 4.39878 17.8334 5.05048 17.8341 5.73021V6.84759C17.8336 7.01189 17.8656 7.17467 17.9284 7.32651C17.9912 7.47835 18.0834 7.61624 18.1998 7.73221L19.1545 8.68684C19.6345 9.1681 19.9041 9.8201 19.9041 10.4998C19.9041 11.1796 19.6345 11.8316 19.1545 12.3128L18.1998 13.2675C18.0833 13.3834 17.9909 13.5212 17.9279 13.6731C17.865 13.8249 17.8328 13.9877 17.8332 14.1521V15.2703C17.8325 15.9501 17.5622 16.6018 17.0815 17.0824C16.6009 17.5631 15.9492 17.8334 15.2695 17.8341H14.1521C13.9877 17.8337 13.8249 17.8659 13.6731 17.9288C13.5212 17.9918 13.3834 18.0842 13.2675 18.2007L12.3128 19.1553C12.0749 19.3935 11.7922 19.5824 11.4811 19.711C11.17 19.8397 10.8365 19.9057 10.4998 19.9052ZM5.72934 4.47809C5.39756 4.47832 5.07943 4.61022 4.84483 4.84483C4.61022 5.07943 4.47832 5.39756 4.47809 5.72934V6.84759C4.4793 7.18479 4.41348 7.51887 4.28445 7.83042C4.15542 8.14196 3.96575 8.42474 3.72646 8.66234L2.77271 9.61609C2.53825 9.85114 2.40659 10.1696 2.40659 10.5016C2.40659 10.8336 2.53825 11.152 2.77271 11.3871L3.72646 12.3408C3.96554 12.5782 4.15509 12.8607 4.28411 13.172C4.41314 13.4832 4.47907 13.8169 4.47809 14.1538V15.2721C4.47832 15.6039 4.61022 15.922 4.84483 16.1566C5.07943 16.3912 5.39756 16.5231 5.72934 16.5233H6.84759C7.18447 16.5226 7.51816 16.5886 7.82936 16.7176C8.14056 16.8466 8.42308 17.036 8.66059 17.275L9.61434 18.2287C9.84939 18.4632 10.1678 18.5948 10.4998 18.5948C10.8318 18.5948 11.1503 18.4632 11.3853 18.2287L12.3391 17.275C12.5766 17.036 12.8591 16.8466 13.1703 16.7176C13.4815 16.5886 13.8152 16.5226 14.1521 16.5233H15.2703C15.6021 16.5231 15.9202 16.3912 16.1549 16.1566C16.3895 15.922 16.5214 15.6039 16.5216 15.2721V14.1521C16.5206 13.8152 16.5865 13.4814 16.7156 13.1702C16.8446 12.859 17.0341 12.5765 17.2732 12.3391L18.227 11.3853C18.4614 11.1503 18.5931 10.8318 18.5931 10.4998C18.5931 10.1678 18.4614 9.84939 18.227 9.61434L17.2732 8.66234C17.0343 8.42483 16.8449 8.14231 16.7158 7.83111C16.5868 7.51991 16.5208 7.18622 16.5216 6.84934V5.72934C16.5214 5.39756 16.3895 5.07943 16.1549 4.84483C15.9202 4.61022 15.6021 4.47832 15.2703 4.47809H14.1521C13.8149 4.4793 13.4808 4.41348 13.1693 4.28445C12.8577 4.15542 12.5749 3.96575 12.3373 3.72646L11.3836 2.77271C11.1485 2.53825 10.8301 2.40659 10.4981 2.40659C10.1661 2.40659 9.84765 2.53825 9.61259 2.77271L8.66234 3.72646C8.42495 3.96554 8.14245 4.15508 7.83122 4.28411C7.52 4.41314 7.18625 4.47907 6.84934 4.47809H5.72934Z" fill="#2D3035"/>
<path d="M9.62474 12.906C9.53855 12.9062 9.45317 12.8893 9.37356 12.8563C9.29395 12.8232 9.2217 12.7747 9.16099 12.7135L7.41099 10.9635C7.29507 10.8391 7.23197 10.6746 7.23497 10.5045C7.23797 10.3345 7.30684 10.1723 7.42708 10.0521C7.54731 9.93184 7.70952 9.86297 7.87954 9.85997C8.04955 9.85697 8.21409 9.92007 8.33849 10.036L9.62474 11.3214L12.661 8.28599C12.7854 8.17007 12.9499 8.10697 13.12 8.10997C13.29 8.11297 13.4522 8.18184 13.5724 8.30208C13.6926 8.42231 13.7615 8.58452 13.7645 8.75454C13.7675 8.92455 13.7044 9.08909 13.5885 9.21349L10.0885 12.7135C10.0278 12.7747 9.95553 12.8232 9.87593 12.8563C9.79632 12.8893 9.71094 12.9062 9.62474 12.906Z" fill="#2D3035"/>
</svg>
);

const CalendarIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
<path d="M11.0005 19.0313C10.8511 19.0312 10.7058 18.9848 10.5865 18.8989C10.4673 18.813 10.3806 18.6924 10.3396 18.5553L9.62548 16.1691C9.31851 15.131 8.73774 14.1854 7.93868 13.4226C7.13961 12.6599 6.14896 12.1055 5.0614 11.8125L2.56165 11.1309C2.4181 11.0916 2.29185 11.0088 2.20197 10.895C2.11209 10.7812 2.06348 10.6425 2.06348 10.5C2.06348 10.3575 2.11209 10.2188 2.20197 10.105C2.29185 9.99119 2.4181 9.90839 2.56165 9.86914L5.0614 9.18752C6.14896 8.8945 7.13961 8.34013 7.93868 7.57739C8.73774 6.81464 9.31851 5.86902 9.62548 4.83089L10.3396 2.44477C10.3807 2.30774 10.4674 2.18723 10.5867 2.10144C10.7059 2.01564 10.8512 1.96924 11.0005 1.96924C11.1498 1.96924 11.2951 2.01564 11.4143 2.10144C11.5335 2.18723 11.6203 2.30774 11.6614 2.44477L12.3755 4.83089C12.6824 5.86902 13.2632 6.81464 14.0623 7.57739C14.8613 8.34013 15.852 8.8945 16.9396 9.18752L19.4393 9.86914C19.5829 9.90839 19.7091 9.99119 19.799 10.105C19.8889 10.2188 19.9375 10.3575 19.9375 10.5C19.9375 10.6425 19.8889 10.7812 19.799 10.895C19.7091 11.0088 19.5829 11.0916 19.4393 11.1309L16.9396 11.8125C15.852 12.1055 14.8613 12.6599 14.0623 13.4226C13.2632 14.1854 12.6824 15.131 12.3755 16.1691L11.6614 18.5553C11.6204 18.6924 11.5337 18.813 11.4144 18.8989C11.2952 18.9848 11.1499 19.0312 11.0005 19.0313ZM5.25298 10.5L5.43631 10.5508C6.74882 10.9045 7.94437 11.5735 8.90873 12.4941C9.87309 13.4146 10.574 14.5558 10.9446 15.8086L10.9977 15.9836L11.0509 15.8086C11.4214 14.5558 12.1224 13.4146 13.0867 12.4941C14.0511 11.5735 15.2466 10.9045 16.5591 10.5508L16.7425 10.5L16.5591 10.4493C15.2466 10.0956 14.0511 9.42649 13.0867 8.50597C12.1224 7.58545 11.4214 6.44424 11.0509 5.19139L11.0005 5.01464L10.9473 5.18964C10.5768 6.44249 9.87584 7.5837 8.91148 8.50422C7.94712 9.42474 6.75157 10.0938 5.43906 10.4475L5.25298 10.5Z" fill="#2D3035"/>
</svg>
);

const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <path d="m4 6 4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const RefreshIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
<path d="M12.2515 7.89663C11.9024 7.84351 11.5923 8.08282 11.5422 8.42401C11.4165 9.28095 11.021 10.0628 10.3984 10.6854C8.81394 12.2699 6.23769 12.2686 4.65381 10.6854C3.07025 9.10151 3.07025 6.52432 4.65381 4.94076C5.2495 4.34538 6.0015 3.9572 6.84312 3.81588C7.20506 3.7472 7.59419 3.73532 7.99794 3.78107C8.55231 3.84488 9.06831 4.02882 9.53919 4.29888L8.7255 4.43782C8.38556 4.49613 8.15662 4.81901 8.21525 5.15926C8.26712 5.46382 8.53144 5.67895 8.8305 5.67895C8.86531 5.67895 8.90069 5.6762 8.93669 5.67007L11.1181 5.29713C11.281 5.26907 11.4269 5.17751 11.5227 5.04201C11.6186 4.90682 11.6564 4.73895 11.6283 4.57538L11.2548 2.39432C11.1974 2.05438 10.8787 1.8267 10.5333 1.88376C10.1934 1.94207 9.96444 2.26526 10.0231 2.60551L10.1214 3.17957C9.51644 2.8402 8.84912 2.62063 8.14012 2.53901C7.60912 2.47857 7.094 2.49538 6.6225 2.5857C5.537 2.76757 4.55069 3.27632 3.77 4.05695C1.69906 6.12788 1.69906 9.49763 3.77 11.5691C4.80544 12.6049 6.16594 13.1225 7.52612 13.1225C8.88662 13.1225 10.2464 12.6049 11.2823 11.5691C12.0959 10.7555 12.6134 9.73076 12.7788 8.60588C12.8289 8.26407 12.5927 7.94663 12.2515 7.89663Z" fill="#2D3035"/>
</svg>
);

const LocationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">
    <path
      d="M10 2.5a5 5 0 0 0-5 5c0 3.6 5 9 5 9s5-5.4 5-9a5 5 0 0 0-5-5Zm0 6.8a1.8 1.8 0 1 1 1.8-1.8A1.8 1.8 0 0 1 10 9.3Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ClockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">
    <circle cx="10" cy="10" r="7" fill="none" stroke="currentColor" strokeWidth="1.4" />
    <path d="M10 6.5v4l2.5 1.5" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const FilterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <path
      d="M2 4h12M4 8h8M6.5 12h3"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Dashboard = () => {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [eventsCount, setEventsCount] = useState(0);
  const [scannersCount, setScannersCount] = useState(0);
  const [eventPerformance, setEventPerformance] = useState([]);
  const [stats, setStats] = useState({
    totalAttendeesRegistered: 0,
    totalTicketsSold: 0,
    averageAttendanceRate: null,
    upcomingEvents: 0,
    activeScannersToday: null,
    hasActiveScannerInsight: false,
    totalRevenue: null,
    sellersCount: 0,
  });
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [overviewFilter, setOverviewFilter] = useState("all");
  const [activityFilter, setActivityFilter] = useState("week");
  const [isOverviewMenuOpen, setIsOverviewMenuOpen] = useState(false);
  const [isActivityMenuOpen, setIsActivityMenuOpen] = useState(false);
  const [highlightSlide, setHighlightSlide] = useState(0);
  const [expandedMobileOrderId, setExpandedMobileOrderId] = useState(null);
  const totalSlides = 2;

  const numberFormatter = useMemo(() => new Intl.NumberFormat("es-AR"), []);
  const currencyFormatter = useMemo(
    () =>
      new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: "ARS",
        maximumFractionDigits: 0,
      }),
    []
  );
  const percentFormatter = useMemo(
    () =>
      new Intl.NumberFormat("es-AR", {
        style: "percent",
        maximumFractionDigits: 0,
      }),
    []
  );
  const shortDateFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat("es-AR", {
        day: "2-digit",
        month: "short",
      }),
    []
  );
  const shortTimeFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat("es-AR", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }),
    []
  );

  const formatCount = (val) => {
    const num = Number(val);
    return Number.isFinite(num) ? numberFormatter.format(num) : "--";
  };
  const formatCurrency = (val) => {
    if (val === null || val === undefined) return "--";
    return currencyFormatter.format(Number(val));
  };
  const formatPercent = (val) => {
    if (typeof val !== "number" || Number.isNaN(val)) return "--";
    return percentFormatter.format(val);
  };
  const formatShortDateTime = (val) => {
    if (val === null || val === undefined) return "--";
    const date = new Date(val);
    if (Number.isNaN(date.getTime())) return "--";
    const dateLabel = shortDateFormatter
      .format(date)
      .replace(/\.$/, "")
      .replace("  ", " ");
    const timeLabel = shortTimeFormatter.format(date);
    return `${dateLabel} \u00B7 ${timeLabel}`;
  };
  const getMobileDateParts = (val) => {
    if (val === null || val === undefined) {
      return { day: "--", time: "--" };
    }
    const date = new Date(val);
    if (Number.isNaN(date.getTime())) return { day: "--", time: "--" };
    const rawDay = shortDateFormatter.format(date).replace(/\.$/, "").trim();
    const formattedDay = rawDay.replace(/\s+/g, "-").toLowerCase();
    const formattedTime = shortTimeFormatter.format(date);
    return { day: formattedDay, time: formattedTime };
  };

  const pickFirstNumber = (...values) => {
    for (const value of values) {
      const num = Number(value);
      if (Number.isFinite(num)) return num;
    }
    return null;
  };

  const loadDashboard = useCallback(async () => {
    try {
      setIsLoading(true);
      const [meResult, statsResult, ordersResult] = await Promise.allSettled([
        organizerMeApi(),
        fetchOrganizerDashboardStats(),
        organizerListOrdersApi(),
      ]);

      if (meResult.status !== "fulfilled") throw meResult.reason;
      if (statsResult.status !== "fulfilled") throw statsResult.reason;

      const meRes = meResult.value;
      const statsRes = statsResult.value;

      setMe(meRes?.data?.info || meRes?.data || null);
      setEventsCount(statsRes?.events?.length || 0);
      setScannersCount(statsRes?.scannersCount || 0);
      setEventPerformance(Array.isArray(statsRes?.eventPerformance) ? statsRes.eventPerformance : []);
      if (statsRes?.stats) {
        setStats((prev) => ({ ...prev, ...statsRes.stats }));
      }

      if (ordersResult.status === "fulfilled") {
        const rawOrders = ordersResult.value?.data?.info ?? ordersResult.value?.data ?? [];
        setOrders(Array.isArray(rawOrders) ? rawOrders : []);
      } else {
        setOrders([]);
      }
    } catch (e) {
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  useEffect(() => {
    const interval = setInterval(() => {
      setHighlightSlide((prev) => (prev + 1) % totalSlides);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setExpandedMobileOrderId(null);
  }, [orders, overviewFilter, activityFilter]);

  const organizationLabel = (() => {
    const options = [
      me?.organizationName,
      me?.organization,
      me?.companyName,
      me?.company,
      me?.businessName,
      me?.name,
    ];
    const value = options.find((entry) => typeof entry === "string" && entry.trim().length > 0);
    return value ? value.trim() : "Mi organizacion";
  })();

  const combinedName = (() => {
    const parts = [me?.firstName, me?.lastName]
      .filter((entry) => typeof entry === "string" && entry.trim().length > 0)
      .join(" ")
      .trim();
    return parts.length ? parts : "";
  })();

  const organizerName = (() => {
    const options = [me?.name, me?.fullName, me?.fullname, combinedName];
    const value = options.find((entry) => typeof entry === "string" && entry.trim().length > 0);
    return value ? value.trim() : "organizador";
  })();

  const {
    totalAttendeesRegistered,
    totalTicketsSold,
    averageAttendanceRate,
    upcomingEvents,
    activeScannersToday,
    hasActiveScannerInsight,
    totalRevenue,
    sellersCount,
  } = stats;

  const normalizeIdValue = (value) => {
    if (value === undefined || value === null) return "";
    if (typeof value === "object") return "";
    const str = String(value).trim();
    return str ? str.toLowerCase() : "";
  };

  const resolveOrderEventIdFromObject = (input) => {
    if (!input || typeof input !== "object") return "";
    const nestedCandidates = [
      input.eventId,
      input.eventid,
      input.eventID,
      input.id,
      input._id,
      input.slug,
      input.reference,
      input.code,
    ];
    for (const candidate of nestedCandidates) {
      const normalized = normalizeIdValue(candidate);
      if (normalized) return normalized;
    }
    return "";
  };

  const getOrderEventId = (order) => {
    if (!order) return "";
    const directCandidates = [
      order.eventId,
      order.event_id,
      order.eventID,
      order.eventid,
      order.eventUuid,
      order.eventuuid,
      order.eventRef,
      order.eventReference,
    ];
    for (const candidate of directCandidates) {
      const normalized = normalizeIdValue(candidate);
      if (normalized) return normalized;
    }
    const objectCandidates = [order.event, order.eventid, order.eventInfo, order.eventDetails];
    for (const obj of objectCandidates) {
      const normalized = resolveOrderEventIdFromObject(obj);
      if (normalized) return normalized;
    }
    return "";
  };

  const normalizeNameValue = (value) => (typeof value === "string" ? value.trim().toLowerCase() : "");

  const getOrderEventName = (order) => {
    const candidates = [
      order.eventid?.name,
      order.event?.name,
      order.eventName,
      order.event,
      order.title,
    ];
    const value = candidates.find((entry) => typeof entry === "string" && entry.trim().length > 0);
    return value ? value : "Evento";
  };

  const getOrderEventNameKey = (order) => normalizeNameValue(getOrderEventName(order));

  const getOrderBuyerName = (order) => {
    const candidates = [
      order.name,
      order.fullName,
      order.fullname,
      order.customerName,
      order.buyerName,
      order.user?.name,
    ];
    const value = candidates.find((entry) => typeof entry === "string" && entry.trim().length > 0);
    return value ? value : organizerName;
  };

  const getOrderNumber = (order) => {
    if (!order) return "--";
    const candidates = [
      order.orderid,
      order.orderId,
      order.order_id,
      order.orderNumber,
      order.orderNo,
      order.orderlabel,
      order.orderLabel,
      order.reference,
      order.code,
      order.shortId,
      order.ticketNumber,
      order.ticketNo,
      order._id,
      order.id,
    ];
    for (const candidate of candidates) {
      if (candidate === undefined || candidate === null) continue;
      const str = typeof candidate === "number" ? String(candidate) : String(candidate).trim();
      if (!str) continue;
      if (/^\d+$/.test(str)) return str;
      if (str.length > 12) return str.slice(-6).toUpperCase();
      return str;
    }
    return "--";
  };

  const getOrderKey = (order, idx) =>
    order?._id ||
    order?.id ||
    order?.orderid ||
    order?.orderId ||
    order?.order_id ||
    order?.orderNumber ||
    order?.orderNo ||
    order?.reference ||
    order?.code ||
    `order-${idx}`;

  const getOrderQuantity = (order) =>
    pickFirstNumber(order.quantity, order.totalbooking, order.totalBooking, order.ticketQuantity, order.totalTickets);

  const getOrderAmount = (order) =>
    pickFirstNumber(order.paidamount, order.paidAmount, order.amountPaid, order.totalamount, order.amount, order.total);

  const overviewOptions = useMemo(() => {
    const options = [...baseOverviewOptions];
    if (!eventPerformance.length) return options;
    const eventOptions = eventPerformance.map((event) => ({
      value: event.id,
      label: event.name || event.code || "Evento sin nombre",
    }));
    return [...options, ...eventOptions];
  }, [eventPerformance]);

  const overviewLabel =
    overviewOptions.find((option) => option.value === overviewFilter)?.label || overviewOptions[0].label;
  const activityLabel =
    activityOptions.find((option) => option.value === activityFilter)?.label || activityOptions[0].label;

  const selectedOverviewEvent = useMemo(() => {
    if (overviewFilter === "all" || overviewFilter === "upcoming") return null;
    if (!eventPerformance.length) return null;
    const match = eventPerformance.find((event) => event.id === overviewFilter);
    return match || null;
  }, [overviewFilter, eventPerformance]);

  const filteredEvents = useMemo(() => {
    if (!eventPerformance.length) return [];
    if (overviewFilter === "upcoming") {
      const now = Date.now();
      return eventPerformance.filter((event) => event.startDateValue && event.startDateValue >= now);
    }
    if (selectedOverviewEvent) return [selectedOverviewEvent];
    return eventPerformance;
  }, [eventPerformance, overviewFilter, selectedOverviewEvent]);

  const getOrderDateValue = (order) => {
    if (!order) return null;
    const candidates = [
      order.createdAt,
      order.created_at,
      order.orderDate,
      order.order_date,
      order.date,
      order.updatedAt,
      order.updated_at,
      order.paidAt,
      order.paymentDate,
    ];
    for (const candidate of candidates) {
      if (!candidate) continue;
      const parsed = new Date(candidate);
      if (!Number.isNaN(parsed.getTime())) return parsed.getTime();
    }
    return null;
  };

  const ordersScopedByEvent = useMemo(() => {
    if (!orders.length) return [];
    if (overviewFilter === "all" || filteredEvents.length === 0) return orders;
    const allowedIds = new Set(
      filteredEvents.map((event) => normalizeIdValue(event.id)).filter((value) => Boolean(value))
    );
    const allowedNames = new Set(
      filteredEvents.map((event) => normalizeNameValue(event.name)).filter((value) => Boolean(value))
    );
    if (!allowedIds.size && !allowedNames.size) return orders;
    return orders.filter((order) => {
      const orderId = getOrderEventId(order);
      if (orderId && allowedIds.has(orderId)) return true;
      const nameKey = getOrderEventNameKey(order);
      if (nameKey && allowedNames.has(nameKey)) return true;
      return false;
    });
  }, [orders, filteredEvents, overviewFilter]);

  const scopedOrdersSold = useMemo(() => {
    if (!selectedOverviewEvent) return null;
    return ordersScopedByEvent.reduce((sum, order) => {
      const qty = getOrderQuantity(order);
      return sum + (Number.isFinite(qty) ? qty : 0);
    }, 0);
  }, [selectedOverviewEvent, ordersScopedByEvent]);

  const selectedOverviewSold = useMemo(() => {
    if (!selectedOverviewEvent) return null;
    const bookedFromEvent = Number(selectedOverviewEvent.bookedTickets);
    const bookedValue = Number.isFinite(bookedFromEvent) ? bookedFromEvent : 0;
    const ordersValue = Number.isFinite(scopedOrdersSold) ? scopedOrdersSold : 0;
    return Math.max(bookedValue, ordersValue);
  }, [selectedOverviewEvent, scopedOrdersSold]);

  const highlightTotals = useMemo(() => {
    if (selectedOverviewEvent && selectedOverviewSold !== null) {
      const attendees = pickFirstNumber(selectedOverviewEvent.checkedIn) ?? 0;
      const isActive = selectedOverviewEvent.isActive ?? true;
      return {
        sold: selectedOverviewSold,
        attendees,
        activeEvents: isActive ? 1 : 0,
      };
    }
    if (!filteredEvents.length) {
      return {
        sold: totalTicketsSold,
        attendees: totalAttendeesRegistered,
        activeEvents: upcomingEvents || eventsCount,
      };
    }
    const sold = filteredEvents.reduce((sum, event) => sum + (pickFirstNumber(event.bookedTickets) ?? 0), 0);
    const attendeesTotal = filteredEvents.reduce((sum, event) => sum + (pickFirstNumber(event.checkedIn) ?? 0), 0);
    const activeEvents = filteredEvents.filter((event) => (event.isActive ?? true)).length || filteredEvents.length;
    return { sold, attendees: attendeesTotal, activeEvents };
  }, [
    filteredEvents,
    totalTicketsSold,
    totalAttendeesRegistered,
    upcomingEvents,
    eventsCount,
    selectedOverviewEvent,
    selectedOverviewSold,
  ]);

  const availableTotal = useMemo(() => {
    if (selectedOverviewEvent && selectedOverviewSold !== null) {
      const capacity = pickFirstNumber(selectedOverviewEvent.capacity);
      if (capacity !== null) {
        return Math.max(capacity - selectedOverviewSold, 0);
      }
      const fallbackAvailable = pickFirstNumber(selectedOverviewEvent.availableTickets);
      if (fallbackAvailable !== null) {
        return Math.max(fallbackAvailable, 0);
      }
      return Math.max(highlightTotals.sold - highlightTotals.attendees, 0);
    }
    if (!filteredEvents.length) {
      return Math.max(totalTicketsSold - totalAttendeesRegistered, 0);
    }
    const available = filteredEvents.reduce((sum, event) => sum + (pickFirstNumber(event.availableTickets) ?? 0), 0);
    if (available > 0) return available;
    return Math.max(highlightTotals.sold - highlightTotals.attendees, 0);
  }, [
    filteredEvents,
    highlightTotals,
    totalTicketsSold,
    totalAttendeesRegistered,
    selectedOverviewEvent,
    selectedOverviewSold,
  ]);

  const ticketBreakdown = useMemo(() => {
    const soldValue = Math.max(highlightTotals.sold, 0);
    const availableValue = Math.max(availableTotal, 0);
    const entries = [
      { key: "sold", label: "Vendidas", value: soldValue, color: "#B1C20E" },
      { key: "available", label: "Disponibles", value: availableValue, color: "#e5e7eb" },
    ];
    const total = entries.reduce((sum, entry) => sum + entry.value, 0);
    return {
      total,
      soldValue,
      availableValue,
      entries: entries.map((entry) => ({
        ...entry,
        percent: total > 0 ? Math.round((entry.value / total) * 100) : 0,
      })),
    };
  }, [highlightTotals, availableTotal]);

  const totalTickets = ticketBreakdown.total || 0;
  const soldPctRaw = totalTickets ? Math.round((ticketBreakdown.soldValue / totalTickets) * 100) : 0;
  const soldPct = Math.min(100, Math.max(0, soldPctRaw));
  const availablePct = totalTickets ? Math.max(0, 100 - soldPct) : 0;
  const donutRadius = 52;
  const donutStrokeWidth = 8;
  const donutCircumference = 2 * Math.PI * donutRadius;
  const donutDashOffset = donutCircumference - (donutCircumference * (soldPct / 100));
  const desktopDonutRadius = 78;
  const desktopDonutStrokeWidth = 14;
  const desktopDonutCircumference = 2 * Math.PI * desktopDonutRadius;
  const desktopDonutDashOffset =
    desktopDonutCircumference - desktopDonutCircumference * (soldPct / 100);

  const mobileBreakdownRows = [
    {
      key: "sold",
      label: "Vendidas",
      value: ticketBreakdown.soldValue,
      percent: soldPct,
      dotColor: "#A6C60A",
    },
    {
      key: "available",
      label: "Disponibles",
      value: ticketBreakdown.availableValue,
      percent: availablePct,
      dotColor: "#E9EDF3",
    },
  ];

  const nextEvent = useMemo(() => {
    if (!eventPerformance.length) return null;
    const upcoming = eventPerformance
      .filter((event) => event.startDateValue && event.startDateValue >= Date.now())
      .sort((a, b) => (a.startDateValue ?? 0) - (b.startDateValue ?? 0));
    if (upcoming.length) return upcoming[0];
    const sortable = [...eventPerformance].sort((a, b) => (a.startDateValue ?? 0) - (b.startDateValue ?? 0));
    return sortable[0] || null;
  }, [eventPerformance]);

  const highlightedEvent = selectedOverviewEvent || nextEvent;
  const sliderLabelText = highlightSlide === 0 ? "Próximo evento" : "Roles asignados";

  const ordersFilteredByDate = useMemo(() => {
    if (!ordersScopedByEvent.length) return [];
    const now = Date.now();
    let threshold = null;
    if (activityFilter === "week") {
      threshold = now - 7 * 24 * 60 * 60 * 1000;
    } else if (activityFilter === "month") {
      threshold = now - 30 * 24 * 60 * 60 * 1000;
    }
    if (threshold === null) return ordersScopedByEvent;
    return ordersScopedByEvent.filter((order) => {
      const ts = getOrderDateValue(order);
      return ts !== null && ts >= threshold;
    });
  }, [ordersScopedByEvent, activityFilter]);

  const recentOrders = useMemo(() => {
    const source = ordersFilteredByDate.length > 0 ? ordersFilteredByDate : ordersScopedByEvent;
    const sorted = [...source].sort((a, b) => (getOrderDateValue(b) ?? 0) - (getOrderDateValue(a) ?? 0));
    return sorted.slice(0, 5);
  }, [ordersFilteredByDate, ordersScopedByEvent]);

  const overviewCards = [
    {
      key: "sold",
      label: "Entradas vendidas",
      value: formatCount(highlightTotals.sold),
      helper: totalRevenue !== null ? `Ingresos ${formatCurrency(totalRevenue)}` : null,
      icon: <TicketIcon />,
    },
    {
      key: "attendees",
      label: "Asistentes registrados",
      value: formatCount(highlightTotals.attendees),
      helper:
        averageAttendanceRate !== null
          ? `Asistencia promedio ${formatPercent(averageAttendanceRate)}`
          : "Esperando datos de check-in",
      icon: <UsersIcon />,
    },
    {
      key: "events",
      label: "Eventos activos",
      value: formatCount(highlightTotals.activeEvents),
      helper: hasActiveScannerInsight
        ? `Escaneres activos ${formatCount(activeScannersToday)}`
        : `Escaneres totales ${formatCount(scannersCount)}`,
      icon: <CalendarIcon />,
    },
  ];

  const formatEventDate = (value, includeTime = false) => {
    if (!value) return "--";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "--";
    const options = includeTime
      ? { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }
      : { day: "numeric", month: "short", year: "numeric" };
    return new Intl.DateTimeFormat("es-AR", options).format(date);
  };

  const handleRefresh = () => {
    if (isLoading) return;
    loadDashboard();
  };

  const handleOrderCardClick = (order) => {
    if (!order) return;
    setSelectedOrder(order);
    setIsOrderModalOpen(true);
  };

  const handleCloseOrderModal = () => {
    setIsOrderModalOpen(false);
    setSelectedOrder(null);
  };

  const toggleMobileOrder = (orderKey) => {
    setExpandedMobileOrderId((prev) => (prev === orderKey ? null : orderKey));
  };

  const handleEditEvent = () => {
    if (!highlightedEvent?.id) return;
    navigate(`/organizer/events/${highlightedEvent.id}`);
  };

  const showInitialLoading = isLoading && !me && !eventPerformance.length;
  if (showInitialLoading) return <SpinLoading />;

  return (
    <div className={`organizer-dashboard ${isLoading ? "is-fetching" : ""}`}>
      {me?.capability && !me?.capability?.canSellPaidTickets && (
        <section className="organizer-section" style={{ marginBottom: 20 }}>
          <div className="organizer-empty-card">
            <strong style={{ display: "block", marginBottom: 8 }}>{me.capability.label}</strong>
            <span>{me.capability.message}</span>
            <div style={{ marginTop: 14 }}>
              <button
                type="button"
                className="organizer-btn"
                onClick={() => navigate("/organizer/payments")}
              >
                Completar validacion de pagos
              </button>
            </div>
          </div>
        </section>
      )}

      <section className="organizer-highlight-section">
        {/* TOP ROW: filter on the left, slider header on the right */}
        <div className="organizer-highlight-top">
          <div className="organizer-highlight-top__left">
            <div className="organizer-filter">
              <button
                type="button"
                className="organizer-chip-button"
                onClick={() => setIsOverviewMenuOpen((prev) => !prev)}
              >
                <FilterIcon />
                <span>Filtrar por: {overviewLabel}</span>
                <ChevronDownIcon />
              </button>
              {isOverviewMenuOpen && (
                <div className="organizer-filter__menu">
                  {overviewOptions.map((option) => (
                    <button
                      type="button"
                      key={option.value}
                      className={option.value === overviewFilter ? "is-active" : ""}
                      onClick={() => {
                        setOverviewFilter(option.value);
                        setIsOverviewMenuOpen(false);
                      }}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <button
              type="button"
              className={`organizer-icon-button organizer-icon-button--small${
                isLoading ? " is-loading" : ""
              }`}
              onClick={handleRefresh}
              disabled={isLoading}
              aria-label="Actualizar resumen"
            >
              <RefreshIcon />
              {isLoading && <span className="organizer-icon-button__spinner" aria-hidden="true" />}
            </button>
          </div>

          {/* SLIDER HEADER ON THE RIGHT (dots + label) */}
          <div className="organizer-highlight-top__right organizer-highlight-top__right--desktop">
            <div className="organizer-slider-dots">
              <button
                type="button"
                className={highlightSlide === 0 ? "is-active" : ""}
                onClick={() => setHighlightSlide(0)}
                aria-label="Ver próximo evento"
              />
              <button
                type="button"
                className={highlightSlide === 1 ? "is-active" : ""}
                onClick={() => setHighlightSlide(1)}
                aria-label="Ver roles asignados"
              />
            </div>
            <p className="organizer-slider-label">
              <span className="organizer-slider-label__badge">
                <img src={sliderArrowIcon} alt="" aria-hidden="true" />
              </span>
              {sliderLabelText}
            </p>
          </div>
        </div>

        {/* SECOND ROW: 3 dark cards + white card */}

        <div className="organizer-highlight-row">
          {overviewCards.map((card) => (
            <article className="organizer-highlight-card" key={card.key}>
              <div className="organizer-highlight-card__icon">{card.icon}</div>
              <div className="organizer-highlight-card__content">
                <span className="label">{card.label}</span>
                <strong>{card.value}</strong>
              </div>
            </article>
          ))}

          <article className="organizer-slider-card organizer-slider-card--mobile">
            <div className="organizer-slider-dots">
              <button
                type="button"
                className={highlightSlide === 0 ? "is-active" : ""}
                onClick={() => setHighlightSlide(0)}
                aria-label="Ver próximo evento"
              />
              <button
                type="button"
                className={highlightSlide === 1 ? "is-active" : ""}
                onClick={() => setHighlightSlide(1)}
                aria-label="Ver roles asignados"
              />
            </div>
            <p className="organizer-slider-label organizer-slider-label--mobile">
              <span className="organizer-slider-label__badge">
                <img src={sliderArrowIcon} alt="" aria-hidden="true" />
              </span>
              {sliderLabelText}
            </p>
          </article>

          <article
            className="organizer-next-event-card organizer-next-event-card--inline"
            style={{ display: highlightSlide === 0 ? "flex" : "none" }}
          >
            {highlightedEvent ? (
              <>
                <h3>{highlightedEvent.name || "Evento sin nombre"}</h3>
                <div className="organizer-next-event__meta">
                  <div>
                    <ClockIcon />
                    <span>{formatEventDate(highlightedEvent.startDateValue, false)}</span>
                  </div>
                  <div>
                    <LocationIcon />
                    <span>{highlightedEvent.location || "Ubicacion a confirmar"}</span>
                  </div>
                </div>
                <button
                  type="button"
                  className="organizer-next-event__cta"
                  onClick={handleEditEvent}
                  disabled={!highlightedEvent?.id}
                >
                  Editar evento
                </button>
              </>
            ) : (
              <div className="organizer-next-event__empty">
                Crea un evento para ver la próxima fecha destacada
              </div>
            )}
          </article>

          <article
            className="organizer-next-event-card organizer-next-event-card--inline organizer-roles-card"
            style={{ display: highlightSlide === 1 ? "flex" : "none" }}
          >
            <div className="organizer-roles-card__body">
              <table className="organizer-roles-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Escaner</td>
                    <td>
                      <span className="role-pill role-pill--success">
                        <span className="dot" />
                        {formatCount(activeScannersToday || 0)} activos
                      </span>
                      <span className="role-pill role-pill--danger">
                        <span className="dot" />
                        {formatCount(Math.max(scannersCount - (activeScannersToday || 0), 0))} inactivos
                      </span>
                    </td>
                  </tr>
              <tr>
                <td>Vendedor</td>
                <td>
                  <span className={`role-pill ${sellersCount ? "role-pill--secondary" : "role-pill--muted"}`}>
                    {sellersCount ? `${formatCount(sellersCount)} registro` : "Sin vendedores registrados"}
                  </span>
                </td>
              </tr>
                  <tr>
                    <td>Organizador</td>
                    <td>
                      <span className="role-pill role-pill--muted">Pronto</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </article>
        </div>
      </section>

      <section className="dashboard-activity">
        <article className="dashboard-activity__donut-card">
          <div className="dashboard-donut">
            <div
              className="dashboard-donut__chart"
              role="img"
              aria-label={`Entradas vendidas ${soldPct}%`}
            >
              <svg
                className="dashboard-donut__progress"
                width="186"
                height="186"
                viewBox="0 0 186 186"
                aria-hidden="true"
                focusable="false"
              >
                <circle
                  className="dashboard-donut__progress-track"
                  cx="93"
                  cy="93"
                  r={desktopDonutRadius}
                  strokeWidth={desktopDonutStrokeWidth}
                  fill="none"
                />
                <circle
                  className="dashboard-donut__progress-value"
                  cx="93"
                  cy="93"
                  r={desktopDonutRadius}
                  strokeWidth={desktopDonutStrokeWidth}
                  strokeDasharray={desktopDonutCircumference}
                  strokeDashoffset={desktopDonutDashOffset}
                  transform="rotate(-90 93 93)"
                  fill="none"
                />
              </svg>
              <div className="dashboard-donut__center">
                <span>Entradas</span>
                <strong>{formatCount(ticketBreakdown.total)}</strong>
              </div>
            </div>
            <ul className="dashboard-donut__legend">
              {ticketBreakdown.entries.map((entry) => (
                <li key={entry.key}>
                  <div className="dashboard-donut__legend-left">
                    <span className="dot" style={{ backgroundColor: entry.color }}></span>
                    <span className="dashboard-donut__legend-label">{entry.label}</span>
                    <span className="dashboard-donut__legend-value">{formatCount(entry.value)}</span>
                  </div>
                  <span className="dashboard-donut__legend-percent">
                    <img className="dashboard-donut__legend-arrow" src={legendArrowIcon} alt="" />
                    {entry.percent}%
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="dashboard-donut-mobile">
            <div
              className="dashboard-donut-mobile__chart"
              role="img"
              aria-label={`Entradas vendidas ${soldPct}%`}
            >
              <svg width="120" height="120" viewBox="0 0 120 120" aria-hidden="true" focusable="false">
                <circle
                  cx="60"
                  cy="60"
                  r={donutRadius}
                  stroke="#E9EDF3"
                  strokeWidth={donutStrokeWidth}
                  fill="none"
                />
                <circle
                  cx="60"
                  cy="60"
                  r={donutRadius}
                  stroke="#A6C60A"
                  strokeWidth={donutStrokeWidth}
                  strokeLinecap="round"
                  strokeDasharray={donutCircumference}
                  strokeDashoffset={donutDashOffset}
                  transform="rotate(-90 60 60)"
                  fill="none"
                />
              </svg>
              <div className="dashboard-donut-mobile__chart-labels">
                <span>Entradas</span>
                <strong>{formatCount(ticketBreakdown.total)}</strong>
              </div>
            </div>
            <div className="dashboard-donut-mobile__stats">
              {mobileBreakdownRows.map((row) => (
                <div className="dashboard-donut-mobile__row" key={row.key}>
                  <span
                    className="dashboard-donut-mobile__row-dot"
                    style={{ backgroundColor: row.dotColor }}
                  />
                  <div className="dashboard-donut-mobile__row-meta">
                    <span className="dashboard-donut-mobile__row-label">{row.label}</span>
                    <strong>{formatCount(row.value)}</strong>
                  </div>
                  <span className="dashboard-donut-mobile__row-pill">
                    <img className="dashboard-donut-mobile__row-arrow" src={legendArrowIcon} alt="" />
                    {row.percent}%
                  </span>
                </div>
              ))}
            </div>
          </div>
        </article>

        <article className="dashboard-activity__table-card">
          <header className="dashboard-activity__table-header">
            <div>
              <p className="dashboard-eyebrow">Actividad reciente de venta</p>
              <h2>Ultimas operaciones</h2>
            </div>
            <div className="dashboard-activity__table-controls">
              <div className="organizer-filter">
                {isActivityMenuOpen && (
                  <div className="organizer-filter__menu">
                    {activityOptions.map((option) => (
                      <button
                        type="button"
                        key={option.value}
                        className={option.value === activityFilter ? "is-active" : ""}
                        onClick={() => {
                          setActivityFilter(option.value);
                          setIsActivityMenuOpen(false);
                        }}
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </header>

          <div className="dashboard-activity__table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>{"N\u00B0"}</th>
                  <th>Evento</th>
                  <th>Nombre</th>
                  <th>Cant.</th>
                  <th>Importe</th>
                  <th>Fecha y hora</th>
                </tr>
              </thead>
              <tbody>
                {recentOrders.map((order, idx) => {
                  const quantity = getOrderQuantity(order);
                  const amount = getOrderAmount(order);
                  const dateValue = getOrderDateValue(order);
                  return (
                    <tr key={order._id || order.id || order.orderid || order.orderId || `order-${idx}`}>
                      <td>{getOrderNumber(order)}</td>
                      <td>{getOrderEventName(order)}</td>
                      <td>{getOrderBuyerName(order)}</td>
                      <td>{quantity !== null ? formatCount(quantity) : "--"}</td>
                      <td>{amount !== null ? formatCurrency(amount) : "--"}</td>
                      <td>{dateValue ? formatEventDate(dateValue, true) : "--"}</td>
                    </tr>
                  );
                })}
                {recentOrders.length === 0 && (
                  <tr>
                    <td className="dashboard-activity__table-empty" colSpan={6}>
                      Sin actividad disponible para este periodo
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="dashboard-activity__mobile-list">
            {recentOrders.map((order, idx) => {
              const quantity = getOrderQuantity(order);
              const amount = getOrderAmount(order);
              const dateValue = getOrderDateValue(order);
              const customerLabel = getOrderBuyerName(order);
              const rawOrderKey = getOrderKey(order, idx);
              const normalizedOrderKey =
                typeof rawOrderKey === "string" || typeof rawOrderKey === "number"
                  ? String(rawOrderKey)
                  : `order-${idx}`;
              const detailId = `mobile-order-detail-${normalizedOrderKey.replace(/[^a-zA-Z0-9_-]/g, "")}`;
              const isExpanded = expandedMobileOrderId === normalizedOrderKey;
              const formattedAmount = amount !== null ? formatCurrency(amount) : "--";
              const quantityLabel = quantity !== null ? `x${formatCount(quantity)}` : "--";
              const formattedDateLabel = dateValue ? formatEventDate(dateValue, false) : "--";
              const orderNumberLabel = getOrderNumber(order);
              return (
                <div
                  className={`dashboard-activity__mobile-card${isExpanded ? " is-open" : ""}`}
                  key={normalizedOrderKey}
                >
                  <button
                    type="button"
                    className="dashboard-activity__mobile-toggle"
                    onClick={() => toggleMobileOrder(normalizedOrderKey)}
                    aria-expanded={isExpanded}
                    aria-controls={detailId}
                  >
                    <span className="dashboard-activity__mobile-toggle-icon" aria-hidden="true">
                      <ChevronDownIcon />
                    </span>
                    <span className="dashboard-activity__mobile-event" title={getOrderEventName(order)}>
                      {getOrderEventName(order)}
                    </span>
                    <span className="dashboard-activity__mobile-amount">{formattedAmount}</span>
                  </button>
                  {isExpanded && (
                    <div
                      className="dashboard-activity__mobile-details"
                      id={detailId}
                    >
                      <div className="dashboard-activity__mobile-details-row">
                        <span className="label">{"N\u00B0 orden"}</span>
                        <span className="value">{orderNumberLabel}</span>
                      </div>
                      <div className="dashboard-activity__mobile-details-row">
                        <span className="label">Nombre</span>
                        <span className="value">{customerLabel}</span>
                      </div>
                      <div className="dashboard-activity__mobile-details-row">
                        <span className="label">Cant.</span>
                        <span className="value">{quantityLabel}</span>
                      </div>
                      <div className="dashboard-activity__mobile-details-row">
                        <span className="label">Fecha</span>
                        <span className="value">{formattedDateLabel}</span>
                      </div>
                      <button
                        type="button"
                        className="dashboard-activity__mobile-detail-link"
                        onClick={() => handleOrderCardClick(order)}
                      >
                        Ver detalle
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
            {recentOrders.length === 0 && (
              <div className="dashboard-activity__mobile-empty">Sin actividad disponible para este periodo</div>
            )}
          </div>
        </article>
      </section>

      <Modal
        show={isOrderModalOpen && !!selectedOrder}
        onHide={handleCloseOrderModal}
        centered
        className="dashboard-order-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Detalle de la operaci&oacute;n</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOrder ? (() => {
            const amount = getOrderAmount(selectedOrder);
            const quantity = getOrderQuantity(selectedOrder);
            const dateValue = getOrderDateValue(selectedOrder);
            return (
              <div className="dashboard-order-modal__content">
                <div className="dashboard-order-modal__summary">
                  <div>
                    <p className="dashboard-order-modal__label">Evento</p>
                    <p className="dashboard-order-modal__value">{getOrderEventName(selectedOrder)}</p>
                  </div>
                  <div className="dashboard-order-modal__amount">
                    {amount !== null ? formatCurrency(amount) : "--"}
                  </div>
                </div>
                <dl className="dashboard-order-modal__list">
                  <div>
                    <dt>N&uacute;mero</dt>
                    <dd>{getOrderNumber(selectedOrder)}</dd>
                  </div>
                  <div>
                    <dt>Cliente</dt>
                    <dd>
                      {getOrderBuyerName(selectedOrder)}
                      {quantity !== null && (
                        <span className="dashboard-order-modal__qty">{` \u00B7 x${formatCount(quantity)}`}</span>
                      )}
                    </dd>
                  </div>
                  <div>
                    <dt>Fecha y hora</dt>
                    <dd>{dateValue ? formatEventDate(dateValue, true) : "--"}</dd>
                  </div>
                </dl>
              </div>
            );
          })() : (
            <p>No se encontró información de esta operación.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Dashboard;
